const EUFlag = () => (
  <svg width="20" height="14" viewBox="0 0 30 20" style={{ marginRight: '6px', verticalAlign: 'middle' }}>
    {/* Blue background */}
    <rect width="30" height="20" fill="#003399"/>
    
    {/* Circle of 12 stars - representing unity and harmony */}
    <g fill="#FFCC00">
      {/* Top star */}
      <polygon points="15,2 15.5,3.5 17,3.5 15.75,4.5 16.25,6 15,5 13.75,6 14.25,4.5 13,3.5 14.5,3.5"/>
      
      {/* Upper right stars */}
      <polygon points="19,4 19.5,5.5 21,5.5 19.75,6.5 20.25,8 19,7 17.75,8 18.25,6.5 17,5.5 18.5,5.5"/>
      <polygon points="22,7 22.5,8.5 24,8.5 22.75,9.5 23.25,11 22,10 20.75,11 21.25,9.5 20,8.5 21.5,8.5"/>
      
      {/* Right star */}
      <polygon points="24,10 24.5,11.5 26,11.5 24.75,12.5 25.25,14 24,13 22.75,14 23.25,12.5 22,11.5 23.5,11.5"/>
      
      {/* Lower right stars */}
      <polygon points="22,13 22.5,14.5 24,14.5 22.75,15.5 23.25,17 22,16 20.75,17 21.25,15.5 20,14.5 21.5,14.5"/>
      <polygon points="19,16 19.5,17.5 21,17.5 19.75,18.5 20.25,20 19,19 17.75,20 18.25,18.5 17,17.5 18.5,17.5"/>
      
      {/* Bottom star */}
      <polygon points="15,18 15.5,19.5 17,19.5 15.75,20.5 16.25,22 15,21 13.75,22 14.25,20.5 13,19.5 14.5,19.5"/>
      
      {/* Lower left stars */}
      <polygon points="11,16 11.5,17.5 13,17.5 11.75,18.5 12.25,20 11,19 9.75,20 10.25,18.5 9,17.5 10.5,17.5"/>
      <polygon points="8,13 8.5,14.5 10,14.5 8.75,15.5 9.25,17 8,16 6.75,17 7.25,15.5 6,14.5 7.5,14.5"/>
      
      {/* Left star */}
      <polygon points="6,10 6.5,11.5 8,11.5 6.75,12.5 7.25,14 6,13 4.75,14 5.25,12.5 4,11.5 5.5,11.5"/>
      
      {/* Upper left stars */}
      <polygon points="8,7 8.5,8.5 10,8.5 8.75,9.5 9.25,11 8,10 6.75,11 7.25,9.5 6,8.5 7.5,8.5"/>
      <polygon points="11,4 11.5,5.5 13,5.5 11.75,6.5 12.25,8 11,7 9.75,8 10.25,6.5 9,5.5 10.5,5.5"/>
    </g>
  </svg>
);

export default EUFlag;
